import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Button, IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ReactTable from "react-table";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    button: {
        width: '100%'
    }
});

class StudentTable extends Component {

    getAddRowContent = (row) => {
        // if (row.enrolled_this_course) {
        //     return (
        //         <Button
        //             disabled={this.props.view_type === 'detail'}
        //             variant="contained"
        //             onClick={() => this.props.toggleStudent(row, 'REMOVE')}
        //             classes={styles.button}
        //         >Drop</Button>
        //     )
        // }
        // else if (!row.enrolled_this_course && !row.schedule_conflict) {
        //     return (
        //         <Button
        //             disabled={this.props.view_type === 'detail'}
        //             variant="contained"
        //             onClick={() => this.props.toggleStudent(row, 'ADD')}
        //             classes={styles.button}
        //         >Add</Button>
        //     )
        // }
        // else {
        //     return (
        //         <Tooltip style={{ marginLeft: '16px', fontSize: '30px' }} title=" Student already enrolled in a course during this time period">
        //             <Icon>cancel</Icon>
        //         </Tooltip>
        //     )
        // }

        if (row.enrolled_this_course) {
            return (
                <Button
                    disabled={this.props.view_type === 'detail'}
                    variant="contained"
                    onClick={() => this.props.toggleStudent(row, 'REMOVE')}
                    classes={styles.button}
                >Drop</Button>
            )
        }

        else {
            return (
                <Button
                    disabled={this.props.view_type === 'detail'}
                    variant="contained"
                    onClick={() => this.props.toggleStudent(row, 'ADD')}
                    classes={styles.button}
                >Add</Button>
            )
        }

    }

    render() {
        const rows = this.props.allStudents

        return (
            <ReactTable
                getTrProps={(state, rows, column) => {
                    if (rows) {
                        if (rows.original.enrolled_this_course) {
                            return { style: { backgroundColor: 'rgba(33, 134, 29, 0.37)' } }
                        }
                        // else if (rows.original.schedule_conflict === 1) {
                        //     return { style: { backgroundColor: 'rgba(186, 3, 3, 0.33)' } }
                        // }
                    }
                    return { style: {} }
                }}
                columns={[
                    {
                        Header: "Student",
                        accessor: "FullName",
                    },
                    {
                        Header: "Email",
                        accessor: "Email",
                    },
                    {
                        Header: "Actions",
                        id: "actions",
                        accessor: a => this.getAddRowContent(a)
                    },
                    {
                        Header: "Status",
                        id: "status",
                        accessor: a => a.enrolled_this_course ? 'Enrolled' : 'Not Enrolled'
                    },
                ]}
                data={rows}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="No Students Found"
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // getAllStudents: Actions.getAgenda
        toggleStudent: Actions.toggleStudent
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
        // students: scheduledCourseApp.scheduledCourses.allStudents
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentTable)));




// WEBPACK FOOTER //
// src/main/content/scheduled_course/StudentTable.js